import { RELEASE } from "../../constants/testIds";

export const Header = ({ sleepControls, lightsLabel, timerLabel, fadeLabel, onLights, onTimer, onFade, onFullscreen }) => {
  return (
    <header>
      <button data-testid={RELEASE.fullscreenButton} className="chip" id="fsBtn" title="Fill the screen" aria-label="Fullscreen" onClick={onFullscreen}>
        <svg viewBox="0 0 24 24"><path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5" /></svg>
      </button>
      {sleepControls && (
        <nav>
          <button data-testid={RELEASE.lightsButton} className="chip" onClick={onLights}>{lightsLabel}</button>
          <button data-testid={RELEASE.timerButton} className="chip" onClick={onTimer}>{timerLabel}</button>
          <button data-testid={RELEASE.fadeButton} className="chip" onClick={onFade}>{fadeLabel}</button>
        </nav>
      )}
    </header>
  );
};
